import { CallsOutlineIcon, ChatIcon, PhoneIcon } from '@beef/ui-kit';
export var ICON_TYPES = {
  call: CallsOutlineIcon,
  chat: ChatIcon,
  phone: PhoneIcon
};